import { ArticleShape } from 'utils/shapes';
import Preview from '../Preview';

const SingleArticle = ({ article }) =>
    Preview({
        url: article.url,
        title: article.title,
        subtitle: article.category.description,
        description: article.ingress,
        image: article.facade && article.facade.thumbnail,
    });

SingleArticle.propTypes = {
    article: ArticleShape.isRequired,
};

export default SingleArticle;



// WEBPACK FOOTER //
// ./src/components/news/SingleArticle.js